import { render, staticRenderFns } from "./flowTop.vue?vue&type=template&id=bb697bd4&scoped=true"
import script from "./flowTop.vue?vue&type=script&lang=js"
export * from "./flowTop.vue?vue&type=script&lang=js"
import style0 from "./flowTop.vue?vue&type=style&index=0&id=bb697bd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb697bd4",
  null
  
)

export default component.exports